import {
    faChartLine,
    faColumns,
    faFile,
    faFont,
    faImage,
    faImages,
    faLayerGroup,
    faList,
    faPenToSquare,
    faQuestionCircle,
    faRepeat,
    faTable,
    type IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { useCallback } from 'react';

const MENU_ICON_BY_ELEMENT_TYPE: Partial<Record<string, IconDefinition>> = {
    text: faPenToSquare,
    plain_text: faFont,
    image: faImage,
    image_gallery: faImages,
    table: faTable,
    graph: faChartLine,
    rows: faList,
    columns: faColumns,
    repeat: faRepeat,
    page: faFile,
    pagebreak: faFile,
    template_include: faLayerGroup,
};

export function useAddElementSlotMenuIcon(): (elementType: string) => IconDefinition {
    return useCallback(
        (elementType: string) => MENU_ICON_BY_ELEMENT_TYPE[elementType] ?? faQuestionCircle,
        []
    );
}
